import React from 'react'
import { Tooltip as TooltipBootstrap } from 'react-bootstrap'
import cn from 'classnames'
import s from './Tooltip.module.scss'

interface Props {
  id: string
  children: React.ReactNode
  className?: string
}

const defaultProps = {
  className: undefined,
}

const Tooltip = React.forwardRef(
  (
    { id, children, className, ...props }: Props,
    ref:
      | ((instance: HTMLDivElement | null) => void)
      | React.RefObject<HTMLDivElement>
      | null
      | undefined
  ): JSX.Element => (
    <TooltipBootstrap
      ref={ref}
      id={id}
      className={cn(s.tooltip, className)}
      {...props}
    >
      {children}
    </TooltipBootstrap>
  )
)

Tooltip.defaultProps = defaultProps
export default Tooltip
